export default __webpack_public_path__ + "static/media/sec4.dbb0869f.svg";